import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const SkeletonCard = () => {
  return (
    <>
      <SkeletonTheme height={100}>
        <div className="row g-3 mb-5">
          <div className="col-4">
            <Skeleton count={1} />
          </div>
          <div className="col-4">
            <Skeleton count={1} />
          </div>
          <div className="col-4">
            <Skeleton count={1} />
          </div>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default SkeletonCard;
